import React from "react";
import SimpleBar from "simplebar-react";
import { Link, useLocation } from "react-router-dom";

import "simplebar/dist/simplebar.min.css";

const SidebarContent = (props) => {

  const pathname = useLocation().pathname
  const mainMenu = [
    {
      name: 'Байгууллага',
      url: '/organization'
    },
    {
      name: 'Картууд',
      url: '/card_info'
    },
    {
      name: 'Карт цэнэглэлт',
      url: '/card_charge'
    },
    {
      name: 'Карт захиалга',
      url: '/card_order'
    },
    {
      name: 'Тайлан',
      url: '/report'
    },
    {
      name: 'ШТС-ын мэдээлэл',
      url: '/gstation'
    }
  ]
  const subMenu = [
    {
      name: 'Тусламж',
      url: '/help'
    },
    {
      name: 'Холбоо барих',
      url: '/contact'
    },
  ]

  return (
    <React.Fragment>
      <SimpleBar className="h-100">
        <div id="sidebar-menu" className="d-flex flex-column h-100">
          <ul className="metismenu list-unstyled">
            {
              mainMenu.map(m => (
                <li key={m.url} className={`menu-title ${pathname === m.url && 'mm-active'}`}>
                  { pathname === m.url && <img src="/images/border.svg"/> }
                  <Link to={m.url} className=" ">
                    {m.name}
                  </Link>
                </li>
              ))
            }
          </ul>
          <div className="flex-grow-1"></div>
          <hr />
          <ul className="metismenu list-unstyled">
            {
              subMenu.map(m => (
                <li key={m.url} className={`menu-title ${pathname === m.url && 'mm-active'}`}>
                  { pathname === m.url && <img src="/images/border.svg"/> }
                  <Link to={m.url} className=" ">
                    {m.name}
                  </Link>
                </li>
              ))
            }
            <li className="menu-title">
              <Link to="#" className="text-danger">
                Гарах
              </Link>
            </li>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

export default SidebarContent;
